"use client";

import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import { useNavigate } from "react-router-dom";

export default function ProductManagementSection ({ searchQuery = "", onSectionChange }) {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [deleteLoading, setDeleteLoading] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch("https://leapatinternational.com/admin/api/v1/product.php");

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const result = await response.json();
                setData(result.data);
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleAddProduct = () => {
        navigate("/dashboard/add-product");
    };

    const handleEditCategory = (category) => {
        // Navigate to edit page with category ID
        navigate(`/dashboard/edit-product/${category.id}`);

        // Alternative: If you want to pass data through state
        // navigate(`/dashboard/edit-category/${category.id}`, {
        //   state: { categoryData: category }
        // })
    };

    const handlePreviewCategory = (category) => {
        toast.info("Preview functionality coming soon!");
    };

    const handleDeleteCategory = async (categoryId) => {
        if (!window.confirm("Are you sure you want to delete this category?")) {
            return;
        }

        try {
            setDeleteLoading(categoryId);

            const data = new FormData();
            data.append("id", categoryId);

            const response = await fetch("https://leapatinternational.com/admin/api/v1/delete_product.php", {
                method: "POST",
                body: data,
            });

            const result = await response.json();

            if (result.status === "success") {
                setData((prev) => prev.filter((cat) => cat.id !== categoryId));
                toast.success("Product deleted successfully!");
            } else {
                toast.error(result.message || "Failed to delete Product");
            }
        } catch (err) {
            console.error("Error:", err);
            toast.error("Network error. Please try again.");
        } finally {
            setDeleteLoading(null);
        }
    };




    return (
        <div className="category-management-section">
            {/* Page Header */}
            <div className="row mb-4">
                <div className="col-12">
                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <h1 className="page-title">Product Management</h1>
                            <p className="page-subtitle">Manage your product inventory and details</p>
                        </div>
                        <button className="add-button" onClick={handleAddProduct}>
                            <i className="bi bi-plus-lg icon-white" style={{ color: 'white', marginRight: '5px' }}></i> Add Product
                        </button>
                    </div>
                </div>
            </div>

            {/* Stats Cards */}
            {/* <div className="row mb-4">
                <div className="col-lg-3 col-md-6 mb-3">
                    <div className="card stat-card">
                        <div className="card-body">
                            <div className="stat-content">
                                <div className="stat-icon">📦</div>
                                <div className="stat-details">
                                    <h3 className="stat-value">{data.length}</h3>
                                    <p className="stat-title">Total Products</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 mb-3">
                    <div className="card stat-card">
                        <div className="card-body">
                            <div className="stat-content">
                                <div className="stat-icon">✅</div>
                                <div className="stat-details">
                                    <h3 className="stat-value">{data.filter((p) => p.status === "Active").length}</h3>
                                    <p className="stat-title">Active Products</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 mb-3">
                    <div className="card stat-card">
                        <div className="card-body">
                            <div className="stat-content">
                                <div className="stat-icon">⚠️</div>
                                <div className="stat-details">
                                    <h3 className="stat-value">{data.filter((p) => p.status === "Out of Stock").length}</h3>
                                    <p className="stat-title">Out of Stock</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-6 mb-3">
                    <div className="card stat-card">
                        <div className="card-body">
                            <div className="stat-content">
                                <div className="stat-icon">💰</div>
                                <div className="stat-details">
                                    <h3 className="stat-value">${data.reduce((sum, p) => sum + p.price * p.stock, 0).toFixed(0)}</h3>
                                    <p className="stat-title">Total Value</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

            {/* Products Table */}
            <div className="row">
                <div className="col-12">
                    <div className="card">
                        <div className="card-header">
                            <h5 className="card-title mb-0">Products List</h5>
                        </div>
                        <div className="card-body">
                            {data.length > 0 ? (
                                <div className="content-table">
                                    <div className="table-responsive">
                                        <table className="table table-hover" style={{ tableLayout: 'fixed', width: '100%' }}>
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '25%' }} >Category Id</th>
                                                    <th style={{ width: '25%' }} >Name</th>
                                                    {/* <th style={{ width: '15%' }} >Price</th>
                                                    <th style={{ width: '15%' }} >Inventory</th> */}
                                                    <th style={{ width: '30%' }} >Image</th>
                                                    <th style={{ width: '20%' }} >Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data.map((item) => (
                                                    <tr key={item.id}>
                                                        <td style={{ width: '25%' }} >
                                                            <h6 className="content-title">{item.category_id}</h6>
                                                        </td>
                                                        <td style={{ width: '25%' }} >
                                                            <div className="content-info">
                                                                <h6 className="content-title">{item.product_name}</h6>
                                                                <span className="content-category">{item.category}</span>
                                                            </div>
                                                        </td>
                                                        {/* <td style={{ width: '15%' }} >
                                                            <div className="content-info">
                                                                <h6 className="content-title">{item.price}</h6>
                                                            </div>
                                                        </td>
                                                        <td style={{ width: '15%' }} >
                                                            <div className="content-info">
                                                                <h6 className="content-title">{item.inventory}</h6>
                                                            </div>
                                                        </td> */}
                                                        <td style={{ width: '30%' }} >
                                                            <img
                                                                src={item.image_gallery[0] || "/placeholder.svg"}
                                                                className="category-image"
                                                                alt={item.title}
                                                                onError={(e) => {
                                                                    e.target.src = "/placeholder.svg";
                                                                }}
                                                            />
                                                        </td>
                                                        <td style={{ width: '20%' }} >
                                                            <div className="action-buttons">
                                                                <button
                                                                    className="btn btn-sm btn-outline-primary"
                                                                    title="Edit"
                                                                    onClick={() => handleEditCategory(item)}
                                                                >
                                                                    ✏️
                                                                </button>

                                                                <button
                                                                    className="btn btn-sm btn-outline-danger"
                                                                    title="Delete"
                                                                    onClick={() => handleDeleteCategory(item.id)}
                                                                    disabled={deleteLoading === item.id}
                                                                >
                                                                    {deleteLoading === item.id ? (
                                                                        <span
                                                                            className="spinner-border spinner-border-sm"
                                                                            role="status"
                                                                            aria-hidden="true"
                                                                        ></span>
                                                                    ) : (
                                                                        "🗑️"
                                                                    )}
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            ) : (
                                <div className="text-center py-5">
                                    <div className="empty-state">
                                        <div className="empty-icon">📂</div>
                                        <h5>No categories found</h5>
                                        <p className="text-muted">
                                            {searchQuery ? `No categories match "${searchQuery}"` : "Start by adding your first category"}
                                        </p>
                                        {!searchQuery && (
                                            <button className="btn btn-primary" onClick={handleAddProduct}>
                                                <i className="bi bi-plus-lg icon-white" style={{ color: 'white', marginRight: '5px' }}></i> Add First Category
                                            </button>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
